export const uk = {
    'client-features': 'Фичи клиента',
    'operator-features': 'Фичи оператора'
};
